<template>
  <a-modal
    :visible="true"
    title="发起活动邀请"
    @ok="sub"
    @cancel="cancel"
    :width="600"
  >
    <div>
      <a-input
        style="width: 150px; margin-right: 10px"
        type="text"
        v-model="search.name"
        placeholder="姓名"
      ></a-input>
      <a-input
        style="width: 150px; margin-right: 10px"
        type="text"
        v-model="search.tel"
        placeholder="手机"
      ></a-input>
      <a-input
        style="width: 150px; margin-right: 10px"
        type="text"
        v-model="search.nickname"
        placeholder="昵称"
      ></a-input>
      <a-button icon="search" style="primary" @click="doSearch"></a-button>
    </div>

    <a-table
      v-if="list.length > 0"
      style="margin-top: 20px"
      size="small"
      :rowKey="(rec) => rec.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="check" slot-scope="text, rec">
        <a-icon v-if="rec.who == form.who" type="check" />
      </template>
      <template slot="headimgurl" slot-scope="text, rec">
        <img height="20px" :src="rec.headimgurl" alt="">
      </template>
      <template slot="action" slot-scope="text, rec">
        <a-button size="small" @click="select(rec)">选择</a-button>
      </template>
    </a-table>
    <p style="font-size: 12px; margin-top :10px">最多显示10条搜索结果</p>
  </a-modal>
</template>

<script>
const columns = [
  {
    title: "check",
    scopedSlots: {
      customRender: "check",
    },
  },
  {
    title: "头像",
    scopedSlots: {
      customRender: "headimgurl",
    },
  },
  {
    title: "昵称",
    dataIndex: "nickname",
  },
  {
    title: "姓名",
    dataIndex: "name",
  },
  {
    title: "手机",
    dataIndex: "tel",
  },
  {
    title: "城市",
    dataIndex: "city",
  },
  {
    title: "操作",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export default {
  data() {
    return {
      columns,
      formItemLayout: {
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 19,
        },
      },
      search: {
        name: "",
        tel: "",
        nickname: "",
      },
      list: [],
      form: {
        activity_id: 0,
        who: "",
        nickname: "",
        headimgurl: "",
        name: "",
        tel: null,
        city: null,
      },
    };
  },
  created() {
    this.form.activity_id = this.$route.query.id;
    console.log(this.form);
  },
  methods: {
    async doSearch() {
      const r = await this.$axios.post('/activity/searchUser', this.search);
      console.log(r);
      if(r.status == 1) this.list = r.list
    },

    select (rec) {
      this.form.who = rec.who;
      this.form.name = rec.name;
      this.form.nickname = rec.nickname;
      this.form.headimgurl = rec.headimgurl;
      this.form.city = rec.city;
      this.form.tel = rec.tel;
    },

    async sub() {
      const that = this;
      const r = await that.$axios.post("/activity/yaoqing", this.form);

      if (r.status == 1) {
        this.callback(true);
      }
    },

    cancel() {
      this.callback(false);
    },

    callback(e) {
      this.$emit("callback", e);
    },
  },
};
</script>